/**
 * Entry Point
 */

import * as React from 'react';
import * as ReactDOM from 'react-dom';
// import { AppContainer } from 'react-hot-loader';

function render() {
  const Root = require('./containers/Root').default;
  ReactDOM.render(
    <Root />,
    document.getElementById('app'),
  );
}

// if (module.hot) {
//   module.hot.accept('./containers/Root', () => {
//     setTimeout(render);
//   });
// }

render();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/index.tsx